export class FormResetButton {

    private resetButton:JQuery<HTMLElement>|null;

    constructor(private form:JQuery<HTMLElement>) {
        this.resetButton = null;
        this.toggleResetButton();

        this.form.on('click', '.select-option[data-value]', (event) => {
            event.stopPropagation();
            this.toggleResetButton();
        });
    }

    private toggleResetButton() {
        if (this.form.find('.selected[data-value="10"], .selected[data-value="11"]').length === 0) {
            if (this.resetButton) {
                this.resetButton.remove();
                this.resetButton = null;
            }
        } else if (!this.resetButton) {
            this.resetButton = $('<button/>')
                .addClass('reset-button')
                .text('Filter zurücksetzen')
                .click(() => this.resetForm());
            this.form.append(this.resetButton);
        }
    }

    private resetForm() {
        let selects = this.form.find('select');

        for (let select of selects) {
            if ($(select).attr('multiple')) {
                $(select).val([]).change();
            } else {
                $(select).val('').change();
            }
        }

        this.form.on('submit', function(event) {
            event.preventDefault();
        });

        this.form.find('[type="submit"]').click();

        this.toggleResetButton();
    }
}

export {};